export default __webpack_public_path__ + "static/media/activities.7f7ae0a9.svg";